/**
 * GSM-03.38 / UCS-2 SMS segment analysis (Twilio-compatible).
 * Duplicated from dashboard-v2 `sms-encoding.ts` for legacy Vue 2 dashboard.
 */

const GSM_BASIC_STR =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";

const GSM_EXT_STR = "^{}\\[~]|€";

const GSM_BASIC = new Set(GSM_BASIC_STR.split(""));
const GSM_EXT = new Set(GSM_EXT_STR.split(""));

export function countGsmSeptets(text) {
  let n = 0;
  for (const ch of text) {
    if (GSM_BASIC.has(ch)) {
      n += 1;
    } else if (GSM_EXT.has(ch)) {
      n += 2;
    } else {
      return -1;
    }
  }
  return n;
}

export function ucs2SegmentCount(utf16Units) {
  if (utf16Units <= 0) {
    return 0;
  }
  if (utf16Units <= 70) {
    return 1;
  }
  return 1 + Math.ceil((utf16Units - 70) / 67);
}

export function gsmSegmentCount(septets) {
  if (septets <= 0) {
    return 0;
  }
  if (septets <= 160) {
    return 1;
  }
  return 1 + Math.ceil((septets - 160) / 153);
}

export function analyzeSmsEncoding(text) {
  const septets = countGsmSeptets(text);
  if (septets >= 0) {
    return {
      encoding: "gsm-7",
      units: septets,
      segments: gsmSegmentCount(septets),
      isUnicode: false,
    };
  }
  const u = text.length;
  return {
    encoding: "ucs-2",
    units: u,
    segments: ucs2SegmentCount(u),
    isUnicode: true,
  };
}

export function maxSegmentsFromBudget(maxLength) {
  if (maxLength <= 0) {
    return 1;
  }
  return Math.max(1, Math.ceil(maxLength / 160));
}

export function smsFitsBudget(text, maxLength) {
  const info = analyzeSmsEncoding(text);
  const allowed = maxSegmentsFromBudget(maxLength);
  return info.segments <= allowed;
}
